module.exports = __webpack_public_path__ + "img/nfc-ic.95f78d2f.svg";